const intialStateAuthState = {
  ssoBasedJourney: false,
  hideDashboardTabOnSidenav: false,
  customerId: null,
  customerRefNum: null,
  Authorization: null,
  ssoCustomerId: null,
  ssoAuthorization: null,
  isSocialLoginNeeded: false,
  showReferralScreen: false,
  completeProfileRoute: null,
  ssoToken: null,
  hypervergeToken: null,
  firstName: '',
  lastName: '',
  marketingQueryParams: {
    utmSource: '',
    campaignId: '',
    adGroupId: '',
    utmTerm: '',
    device: '',
    sourceName: '',
    medium: '',
  },
  ackScreen: {
    statusCode: null,
    statusMsg: null,
    statusDes: null,
    bgImg: null,
    fiboLottieJSON: null,
  },
  validateSSOTokenAPICall: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    response: {},
  },
  logoutAPICall: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    response: {},
  },
};

export default intialStateAuthState;
